import { CostGreenIcon, TimeGreenIcon } from "@assets/icons";
import { Tooltip } from "@altimateai/lego";
import { Stack } from "@altimateai/lego";

const InsightLabel = ({
  tag,
}: {
  tag: { name: string; cost_savings: boolean; time_savings: boolean };
}) => {
  return (
    <Stack align="center" gap="xxs" className="al-w-full al-min-w-0">
      <Tooltip title={tag.name}>
        <div className="al-truncate al-flex-1 al-min-w-0">{tag.name}</div>
      </Tooltip>
      {tag.cost_savings && (
        <Tooltip title="Cost savings for the insights is available">
          <Stack align="center" className="al-shrink-0">
            <CostGreenIcon className="al-h-4 al-w-4" />
          </Stack>
        </Tooltip>
      )}
      {tag.time_savings && (
        <Tooltip title="Time savings for the insights is available">
          <Stack align="center" className="al-shrink-0">
            <TimeGreenIcon className="al-h-4 al-w-4" />
          </Stack>
        </Tooltip>
      )}
    </Stack>
  );
};

export default InsightLabel;
